import { render } from "./AdminCreatorDetail.vue?vue&type=template&id=2b5cec7d&scoped=true"
import script from "./AdminCreatorDetail.vue?vue&type=script&lang=js"
export * from "./AdminCreatorDetail.vue?vue&type=script&lang=js"

import "./AdminCreatorDetail.vue?vue&type=style&index=0&id=2b5cec7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5cec7d"]])

export default __exports__